// import React, { useEffect, useRef, useState } from "react";
// import { Button } from "reactstrap";
// import toast, { Toaster } from "react-hot-toast";

// export const PrintBill = ({
//   currentOrder,
//   totalAmountBeforeDiscount,
//   totalDiscount,
//   serviceCharge,
//   taxAmount,
//   netAmount,
//   customerData,
// }) => {
//   console.log("🚀 ~ customerData:", customerData);
//   const socketRef = useRef(null);
//   const [connectionStatus, setConnectionStatus] = useState("disconnected");
//   const [userInfo, setUserInfo] = useState(null);
//   const [webSocketUrl, setWebSocketUrl] = useState(null);

//   // Load user info from localStorage and construct WebSocket URL
//   useEffect(() => {
//     const storedUserInfo = localStorage.getItem("user");
//     if (storedUserInfo) {
//       const parsedUserInfo = JSON.parse(storedUserInfo);
//       console.log("🚀 ~ useEffect ~ parsedUserInfo:", parsedUserInfo);
//       setUserInfo(parsedUserInfo);

//       const orgInfo = parsedUserInfo?.organizationInfo;
//       if (orgInfo && orgInfo.printPort) {
//         const dynamicWebSocketUrl = `ws://localhost:${orgInfo.printPort}`;
//         setWebSocketUrl(dynamicWebSocketUrl);
//       }
//     }
//   }, []);

//   // WebSocket connection logic
//   useEffect(() => {
//     if (!webSocketUrl) return;

//     const connectWebSocket = () => {
//       setConnectionStatus("connecting");
//       socketRef.current = new WebSocket(webSocketUrl);

//       socketRef.current.onopen = () => {
//         console.log("WebSocket connection established");
//         setConnectionStatus("connected");
//       };

//       socketRef.current.onclose = () => {
//         console.log("WebSocket connection closed");
//         setConnectionStatus("disconnected");
//       };

//       socketRef.current.onerror = (error) => {
//         console.error("WebSocket error:", error);
//         setConnectionStatus("error");
//         toast.error("Connection error. Please refresh or try again later.", {
//           duration: 4000,
//           position: "top-right",
//           style: {
//             background: "#fee2e2",
//             color: "#b91c1c",
//           },
//         });
//       };
//     };

//     connectWebSocket();

//     return () => {
//       if (socketRef.current) {
//         socketRef.current.close();
//       }
//     };
//   }, [webSocketUrl]);

//   const handlePrintBill = () => {
//     if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
//       // Transform currentOrder into the desired items format
//       const formattedItems = currentOrder.map((item) => ({
//         itemName: item.title,
//         quantity: item.quantity,
//         unitPrice: item.price || 0,
//         totalPrice: item.totalPrice || item.price * item.quantity,
//       }));

//       // Construct the bill data in the requested format
//       const billData = {
//         cafeName: userInfo?.organizationInfo?.name, // Use org name if available
//         location: userInfo?.organizationInfo.address1, // Use org location if available
//         type: "PRINT_BILL",
//         phone: userInfo.user.phoneNumber, // Use org phone if available
//         customername: customerData?.name,
//         customeraddress: customerData?.address,
//         customerphone: customerData?.phoneNumber,
//         billremarks: customerData?.remarks,
//         billprintedby: userInfo.userName,
//         items: formattedItems,
//         subTotal: totalAmountBeforeDiscount || 0,
//         discount: totalDiscount || 0,
//         vat: taxAmount || 0,
//         serviceCharge: serviceCharge || 0,
//         netAmount: netAmount || 0,
//         message: "Thank you for visiting!",
//       };

//       socketRef.current.send(JSON.stringify(billData));
//     } else {
//       console.error("WebSocket not connected");
//       setConnectionStatus("error");
//       toast.error("WebSocket not connected. Please try again.", {
//         duration: 4000,
//         position: "top-right",
//         style: {
//           background: "#fee2e2",
//           color: "#b91c1c",
//         },
//       });
//     }
//   };

//   return (
//     <div>
//       <Toaster />
//       <Button
//         color="secondary"
//         onClick={handlePrintBill}
//         disabled={connectionStatus === "connecting" || !webSocketUrl}
//       >
//         {connectionStatus === "connecting" ? "Connecting..." : "Print Bill"}
//       </Button>
//     </div>
//   );
// };

import React, { useEffect, useRef, useState } from "react";
import { Button } from "reactstrap";
import toast, { Toaster } from "react-hot-toast";

export const PrintBill = ({
  currentOrder,
  customerData,
  responseData,
  apiOrderedItems,
  netAmount,
  discountAmount,
  selectedPaymentType,
  selectedTable,
}) => {
  console.log("🚀 ~ PrintBill ~ selectedTable:", selectedTable)
 
  if (!apiOrderedItems.length) {
    return <div>No items available</div>;
  }

  const {
    serviceCharge,
    taxAmount,
    itemAmount,
    itemPrice,
    finalAmount,
    taxPercentage,
  } = apiOrderedItems[0];
  console.log("🚀 ~ PrintBill ~ finalAmount:", finalAmount);
  console.log("🚀 ~ PrintBill ~ itemAmount:", itemAmount);
  console.log("🚀 ~ PrintBill ~ taxAmount:", taxAmount);
  const totalNetAmount = itemAmount + taxAmount - (discountAmount || 0);
  console.log("🚀 ~ PrintBill ~ totalNetAmount:", totalNetAmount);
  const socketRef = useRef(null);
  const [connectionStatus, setConnectionStatus] = useState("disconnected");
  const [userInfo, setUserInfo] = useState(null);
  const [webSocketUrl, setWebSocketUrl] = useState(null);
  const [isPrinting, setIsPrinting] = useState(false);

  // Load user info from localStorage and construct WebSocket URL
  useEffect(() => {
    const storedUserInfo = localStorage.getItem("user");
    if (storedUserInfo) {
      const parsedUserInfo = JSON.parse(storedUserInfo);
      console.log("🚀 ~ useEffect ~ parsedUserInfo:", parsedUserInfo);
      setUserInfo(parsedUserInfo);

      const orgInfo = parsedUserInfo?.organizationInfo;
      if (orgInfo && orgInfo.printPort) {
        const dynamicWebSocketUrl = `ws://localhost:${orgInfo.printPort}`;
        setWebSocketUrl(dynamicWebSocketUrl);
      }
    }
  }, []);

  // WebSocket connection logic
  useEffect(() => {
    if (!webSocketUrl) return;

    const connectWebSocket = () => {
      setConnectionStatus("connecting");
      socketRef.current = new WebSocket(webSocketUrl);

      socketRef.current.onopen = () => {
        console.log("WebSocket connection established");
        setConnectionStatus("connected");
      };

      socketRef.current.onclose = () => {
        console.log("WebSocket connection closed");
        setConnectionStatus("disconnected");
      };

      socketRef.current.onerror = (error) => {
        console.error("WebSocket error:", error);
        setConnectionStatus("error");
        toast.error("Connection error. Please refresh or try again later.", {
          duration: 4000,
          position: "top-right",
          style: {
            background: "#fee2e2",
            color: "#b91c1c",
          },
        });
      };

      socketRef.current.onmessage = (event) => {
        try {
          const response = JSON.parse(event.data);
          if (response.status === "success") {
            toast.success(response.message || "Bill printed successfully", {
              duration: 4000,
              position: "top-right",
              style: {
                background: "#dcfce7",
                color: "#166534",
              },
            });
          }
          setIsPrinting(false);
        } catch (error) {
          console.error("Error parsing WebSocket response:", error);
          setIsPrinting(false);
        }
      };
    };

    connectWebSocket();

    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
    };
  }, [webSocketUrl]);

  const handlePrintBill = () => {
    if (socketRef.current && socketRef.current.readyState === WebSocket.OPEN) {
      setIsPrinting(true);

      // Transform currentOrder into the desired items format
      const formattedItems = currentOrder?.map((item) => ({
        itemName: item.title,
        quantity:
          item.complimentryQuantity > 0 && item?.quantity > 0
            ? item.complimentryQuantity + item?.quantity
            : item.complimentryQuantity > 0
            ? item.complimentryQuantity
            : item?.quantity,

        unitPrice: item.itemPrice / item?.quantity || 0,
        totalPrice: item.itemPrice,
      }));
      console.log("🚀 ~ handlePrintBill ~ formattedItems:", formattedItems);

      // Construct the bill data in the requested format
      const billData = {
        salesInvoiceNumber: responseData?.invoiceNumber,

        cafeName: userInfo?.organizationInfo?.name, // Use org name if available
        location: userInfo?.organizationInfo.address1, // Use org location if available
        type: "PRINT_BILL",
        phone: userInfo?.organizationInfo.tel, // Use org phone if available
        customername: customerData?.name,
        customeraddress: customerData?.address,
        customerphone: customerData?.phoneNumber,
        billremarks: customerData?.remarks,
        billprintedby: userInfo.userName,
        items: formattedItems,
        subTotal: itemAmount || 0,
        discount: discountAmount || 0,
        vat: taxAmount || 0,
        serviceCharge: serviceCharge || 0,
        netAmount: totalNetAmount || 0,
        paymentTypes: [
          { method: selectedPaymentType?.label, amount: totalNetAmount },
        ],
        tableName: selectedTable?.label,
        message: "Thank you for visiting!",
      };
      console.log("🚀 ~ handlePrintBill ~ billData:", billData);

      socketRef.current.send(JSON.stringify(billData));
    } else {
      console.error("WebSocket not connected");
      setConnectionStatus("error");
      toast.error("WebSocket not connected. Please try again.", {
        duration: 4000,
        position: "top-right",
        style: {
          background: "#fee2e2",
          color: "#b91c1c",
        },
      });
    }
  };

  return (
    <div>
      <Toaster />
      <Button
        color="success"
        onClick={handlePrintBill}
        disabled={
          connectionStatus === "connecting" || !webSocketUrl || isPrinting
        }
      >
        {isPrinting ? (
          "Printing..."
        ) : connectionStatus === "connecting" ? (
          "Connecting..."
        ) : (
          <>
            <i className="bx bx-printer"></i> Print
          </>
        )}
      </Button>
    </div>
  );
};
